<template>
    <div class="homepage page-content margin-top-10">
        <div class="content mobile-display">
            <carousel :autoplay="false" :nav="true" :items="3" :margin="15" :dots="false" :navText="['<', '>']">
                <SliderAbout
                    link="about-generali"
                    image="home/quick_action/about_generali.png"/>
                <SliderAbout
                    link="life-insurance-opportunity"
                    image="home/quick_action/life_insurance_opportunity.png"/>
                <SliderAbout
                    link="perks"
                    image="home/quick_action/my_potential_income.png"/>
                <SliderAbout
                    link="explore-the-world"
                    image="home/quick_action/explore_the_world.png"/>
                <SliderAbout
                    link="awards"
                    image="home/quick_action/awards_recogition.png"/>
                <SliderAbout
                    link="success-roadmap"
                    image="home/quick_action/my_success_roadmap.png"/>
                <SliderAbout
                    link="bussiness-opportunity-support-scheme"
                    image="home/quick_action/business_opportunity_support_scheme.png"/>
                <SliderAbout
                    link="talent-profiling-guide"
                    image="home/quick_action/my_talent_profiling_guide.png"/>
                <SliderAbout
                    link="career-lifestyle-survey"
                    image="home/quick_action/career_lifestyle_survey_guide.png"/>
            </carousel>
        </div>
        <div class="content ipad-display">
            <carousel :autoplay="false" :nav="true" :items="4" :margin="15" :dots="false" :navText="['<', '>']">
            <SliderAbout
                    link="about-generali"
                    image="home/quick_action/iPad/about_generali.png"/>
                <SliderAbout
                    link="life-insurance-opportunity"
                    image="home/quick_action/iPad/life_insurance_opportunity.png"/>
                <SliderAbout
                    link="perks"
                    image="home/quick_action/iPad/my_potential_income.png"/>
                <SliderAbout
                    link="explore-the-world"
                    image="home/quick_action/iPad/explore_the_world.png"/>
                <SliderAbout
                    link="awards"
                    image="home/quick_action/iPad/awards_recogition.png"/>
                <SliderAbout
                    link="success-roadmap"
                    image="home/quick_action/iPad/my_success_roadmap.png"/>
                <SliderAbout
                    link="bussiness-opportunity-support-scheme"
                    image="home/quick_action/iPad/business_opportunity_support_scheme.png"/>
                <SliderAbout
                    link="talent-profiling-guide"
                    image="home/quick_action/iPad/my_talent_profiling_guide.png"/>
                <SliderAbout
                    link="career-lifestyle-survey"
                    image="home/quick_action/iPad/career_lifestyle_survey_guide.png"/>
            </carousel>
        </div>

        <div class="content bottom-0 left-text">
            <p class="home-title bottom-0">Generali Convention</p>
            <p class="home-desc bottom-20 color-white">
                Best Convention Destination
            </p>
           <span class="toggle-icon"><img v-bind:src="'images/mpower-new/home/generali_convention/icon.png'"></span>
        </div>
        <div class="content mobile-display">
            <carousel :autoplay="false" :nav="false" :items="2" :margin="15" :dots=false>
                <SliderSingle
                    title="Hokkaido"
                    title2="Japan"
                    image="home/generali_convention/star.png"
                    description="Japan"
                    modal="star-modal"
                    menu="menu-star"
                    positionSlide2="240px"
                    image2="home/generali_convention/star.png"
                    description1="Generali Star Convention"
                    description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
                    link="star"

                    y1y2agentspvi="140,000"
                    agentspvi="180,000"
                    leaderpspvi="250,000"
                    directunitpvi="540,000"
                    grouppvi="1,080,000"

                    badge="explore_the_world/logo/star.png"
                    bannerBadge="star-badge.png"
                    />
                <SliderSingle
                    title="Paris"
                    title2="France"
                    image="home/generali_convention/elite.png"
                    description="France"
                    modal="elite-modal"
                    menu="menu-elite"
                    positionSlide2="145px"
                    image2="home/generali_convention/elite.png"
                    description1="Generali Elite Convention"
                    description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
                    link="elite"

                    y1y2agentspvi="290,000"
                    agentspvi="370,000"
                    leaderpspvi="520,000"
                    directunitpvi="1,110,000"
                    grouppvi="2,220,000"

                    badge="explore_the_world/logo/elite.png"
                    bannerBadge="elite-badge.png"
                    />
            </carousel>
        </div>
        <div class="content ipad-display">
            <carousel :autoplay="false" :nav="false" :items="2" :margin="15" :dots=false>
                <SliderSingle
                   title="Hokkaido"
                    title2="Japan"
                    image="home/generali_convention/star.png"
                    description="Japan"
                    modal="star-modal"
                    menu="menu-star"
                    positionSlide2="240px"
                    image2="home/generali_convention/star.png"
                    description1="Generali Star Convention"
                    description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
                    link="star"

                    y1y2agentspvi="140,000"
                    agentspvi="180,000"
                    leaderpspvi="250,000"
                    directunitpvi="540,000"
                    grouppvi="1,080,000"

                    badge="explore_the_world/logo/star.png"
                    bannerBadge="star-badge.png"
                    />
                <SliderSingle
                    title="Paris"
                    title2="France"
                    image="home/generali_convention/elite.png"
                    description="France"
                    modal="elite-modal"
                    menu="menu-elite"
                    positionSlide2="145px"
                    image2="home/generali_convention/elite.png"
                    description1="Generali Elite Convention"
                    description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
                    link="elite"

                    y1y2agentspvi="290,000"
                    agentspvi="370,000"
                    leaderpspvi="520,000"
                    directunitpvi="1,110,000"
                    grouppvi="2,220,000"

                    badge="explore_the_world/logo/elite.png"
                    bannerBadge="elite-badge.png"
                    />
            </carousel>
        </div>
        <ExploreBannerContent
            video="explore_the_world/video/Generali Star Convention.mp4"
            modal="star-modal"
            title="Hokkaido"
            title1="Japan"
            menu="menu-star"
            positionSlide2="240px"
            image="star.png"
            description1="Generali Star Convention"
            description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
            description3=""
            link="star"
            
            y1y2agentspvi="140,000"
            agentspvi="180,000"
            leaderpspvi="250,000"
            directunitpvi="540,000"
            grouppvi="1,080,000"
            
            badge="explore_the_world/logo/star.png"
            bannerBadge="star-badge.png"
        />
        <ExploreBannerContent
            video="explore_the_world/video/Generali Elite Convention.mp4"
            modal="elite-modal"
            title="Paris"
            title1="France"
            menu="menu-elite"
            positionSlide2="145px"
            image="elite.png"
            description1="Generali Elite Convention"
            description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
            description3=""
            link="elite"
    
            y1y2agentspvi="290,000"
            agentspvi="370,000"
            leaderpspvi="520,000"
            directunitpvi="1,110,000"
            grouppvi="2,220,000"

            badge="explore_the_world/logo/elite.png"
            bannerBadge="elite-badge.png"
        />
        <div class="content bottom-0 left-text">
            <p class="home-title bottom-0">Highlight</p>
            <p class="home-desc bottom-20 color-white">
              &nbsp;
            </p>
            <span class="toggle-icon"><img v-bind:src="'images/mpower-new/home/highlight/icon.png'"></span>
        </div>
        <div class="content mobile-display">
            <carousel :autoplay="false" :nav="false" :items="2" :margin="15" :dots=false>
                <SliderHighlight
                    image="home/highlight/my_talent_profiling_guide.png"
                    link="talent-profiling-guide"
                    back="home"
                />
                <SliderHighlight
                    image="home/highlight/career_lifestyle_survey_guide.png"
                    link="career-lifestyle-survey"
                    back=""
                />
            </carousel>
        </div>
        <div class="content ipad-display">
            <carousel :autoplay="false" :nav="false" :items="4" :margin="15" :dots=false>
                <SliderHighlight
                    image="home/highlight/iPad/my_talent_profiling_guide.png"
                    link="talent-profiling-guide"
                    back="home"
                />
                <SliderHighlight
                    image="home/highlight/iPad/career_lifestyle_survey_guide.png"
                    link="career-lifestyle-survey"
                    back=""
                />
            </carousel>
        </div>
        <div class="divider divider-margins"></div>
    </div>
</template>

<script>
import SliderAbout from '../components/SliderAbout.vue'
import SliderSingle from '../components/SliderSingle.vue'
import SliderHighlight from '../components/SliderHighlight.vue'
import ExploreBannerContent from '../components/ExploreBannerContent.vue'
import carousel from 'vue-owl-carousel'

export default {
  name: 'Home',
  components: {
    SliderAbout,
    SliderSingle,
    SliderHighlight,
    ExploreBannerContent,
    carousel,
  }, 
  mounted(){
      document.querySelector(".header-s").style.display = "block";
      document.querySelector(".header").style.zIndex = "96";
  },
}
</script>
<style scoped>
.home-title{
    font-size: 24px;
    font-family: "HelveticaNeueLTStd-Bd";
    color: #fff;
    line-height: revert;
}

.home-desc{
    font-size: 14px;
    color: #fff;
    font-family: "HelveticaNeueLTStd-Roman";
}
</style>
